// @flow
import { DatePeriod } from 'rgs-nfd-ui-kit/ko-components/date-period/date-period';
import { default as DatePeriodTemplate } from './templates/index.html';
export * from './date-period';

export const COMPONENTS_DATE_PERIOD_NAME = 'date-period';

export const COMPONENTS_DATE_PERIOD_ENTITIES = [
	{
		name: COMPONENTS_DATE_PERIOD_NAME,
		entity: DatePeriod,
		template: DatePeriodTemplate,
	},
];
